import React, { useMemo } from 'react';
import type { CountryFlagProps } from '@components/moleculs/country-flag/types';

import { CountryImage } from './styles';

export const CountryFlag: React.FC<CountryFlagProps> = ({ name, className, style }) => {
    const src = useMemo(() => `https://flagcdn.com/w20/${name.toLowerCase()}.png`, [name]);

    if (!name) {
        return <React.Fragment />;
    }

    return <CountryImage className={className} loading='lazy' src={src} alt={name} style={style} />;
};
